module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "space"
  }), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('a', {
    attrs: {
      "id": "Copyright"
    }
  }, [_vm._v("Published by"), _c('br'), _vm._v("\nGrub Street"), _c('br'), _vm._v("\n4 Rainham Close"), _c('br'), _vm._v("\nLondon SW11 6SS")])]), _c('a', {
    attrs: {
      "id": "Copyright"
    }
  }, [_c('p', {
    staticClass: "copyright3"
  }, [_vm._v("Copyright © Grub Street 2012"), _c('br'), _vm._v("\nCopyright text © Christopher Shores, Giovanni Massimello,"), _c('br'), _vm._v("\nRussell Guest, Frank Olynyk and Winfried Bock 2012")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_c('b', [_vm._v("British Library Cataloguing in Publication Data")]), _c('br'), _vm._v("\nA CIP record for this title is available from the British Library")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_c('b', [_vm._v("ISBN-13: 9781909166127"), _c('br'), _vm._v("\nEPUB ISBN: 9781910690970"), _c('br'), _vm._v("\nPRC ISBN: 9781910690970")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("All rights reserved. No part of this publication my be reproduced, stored in a retrieval system, or transmitted in any form or by any means electronic, mechanical, photocopying, recording or otherwise, without prior permission of the copyright owner.")])]), _c('p', {
    staticClass: "copyright3"
  }, [_c('a', {
    attrs: {
      "id": "Copyright"
    }
  }, [_vm._v("Cover design by Sarah Driver"), _c('br'), _vm._v("\nDesign by Roy Platten, Eclipse, Hemel Hempstead"), _c('br')]), _c('a', {
    attrs: {
      "href": "http://roy.eclipse@btopenworld.com",
      "target": "_blank"
    }
  }, [_vm._v("roy.eclipse@btopenworld.com")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("Printed and bound by Berforts Group, UK")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("Grub Street Publishing only uses FSC"), _c('br'), _vm._v("\n(Forest Stewardship Council) paper for its books.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3cbebeee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/03_Copyright.vue
// module id = 60
// module chunks = 0